import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";

const redirecionarSeForCAEE = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
  }

  currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    return next({ name: "login" });
  }

  const caeeRoles = [
    "psicologo",
    "psicopedagogo",
    "fonoaudiologo",
    "terapeuta-ocupacional",
    "coordenador-caee",
    "gerente-administrativo",
    "diretor-caee",
  ];

  if (caeeRoles.includes(currentUser.roleName)) {
    return next({ name: "educacaoInclusiva.home" });
  }

  return next();
};

export default redirecionarSeForCAEE;
